import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/home.css';

export default class TourPlace extends Component {
  render() {
    const destinations = [
      {
        name: "MUNNAR",
        image: "assets/img/places/Munnar.jpg",
        link: "/munnar",
        description: "Explore the lush green tea gardens and misty hills of Munnar",
        duration: "2-3 Days",
        bestTime: "Sep-Mar",
        color: "#2ecc71"
      },
      {
        name: "KANYAKUMARI",
        image: "assets/img/places/kanyakumari.jpg",
        link: "/kanyakumari",
        description: "Witness the mesmerizing sunrise at the southern tip of India",
        duration: "1-2 Days",
        bestTime: "Oct-Mar",
        color: "#3498db"
      },
      {
        name: "ALLEPPEY",
        image: "assets/img/places/alleppey.jpg",
        link: "/Alappuzha",
        description: "Experience the enchanting backwaters and houseboat cruises",
        duration: "1-2 Days",
        bestTime: "Nov-Feb",
        color: "#1abc9c"
      },
      {
        name: "TRIVANDRUM",
        image: "assets/img/places/KOVALAM.jpg",
        link: "/kovalam",
        description: "Relax on pristine beaches and visit historic temples",
        duration: "2-3 Days",
        bestTime: "Sep-Mar",
        color: "#e74c3c"
      },
      {
        name: "COCHIN",
        image: "assets/img/places/cochin.jpg",
        link: "/cochin",
        description: "Experience the historic Fort Kochi and Chinese fishing nets",
        duration: "2 Days",
        bestTime: "Sep-Mar",
        color: "#2980b9"
      },
      {
        name: "KUMARAKOM",
        image: "assets/img/places/Kumarakom_1.jpg",
        link: "/Kumarakom",
        description: "Immerse in the serene backwaters and bird sanctuary",
        duration: "1-2 Days",
        bestTime: "Nov-Feb",
        color: "#9b59b6"
      },
      {
        name: "THEKKADY",
        image: "assets/img/places/thekkady.jpg",
        link: "/Thekkady",
        description: "Explore wildlife sanctuaries and spice plantations",
        duration: "2 Days",
        bestTime: "Oct-Jun",
        color: "#16a085"
      },
      {
        name: "RAMESWARAM",
        image: "assets/img/places/rameshwaram-temple.jpg",
        link: "/rameshwaram",
        description: "Visit sacred temples and pristine beaches",
        duration: "1-2 Days",
        bestTime: "Oct-Apr",
        color: "#d35400"
      },
      {
        name: "MADURAI",
        image: "assets/img/places/MADURAI.jpg",
        link: "/madurai",
        description: "Discover the ancient Meenakshi Temple and rich culture",
        duration: "2 Days",
        bestTime: "Oct-Mar",
        color: "#c0392b"
      },
      {
        name: "WAYANAD",
        image: "assets/img/places/soojipara.jpg",
        link: "/wayanad",
        description: "Trek through lush forests and explore waterfalls",
        duration: "2-3 Days",
        bestTime: "Oct-May",
        color: "#27ae60"
      },
      {
        name: "JATAYU ROCK",
        image: "assets/img/places/Jatayu.jpg",
        link: "/Jatayu",
        description: "Visit the world's largest bird sculpture and adventure park",
        duration: "1 Day",
        bestTime: "All Year",
        color: "#f39c12"
      },
      {
        name: "GURUVAYUR",
        image: "assets/img/places/guruvayur.jpg",
        link: "/guruvayur",
        description: "Visit the famous Guruvayur Temple and spiritual sites",
        duration: "1 Day",
        bestTime: "All Year",
        color: "#8e44ad"
      }
    ];

    return (
      <div className="destinations-section">
        {/* Hero Header */}
        <div className="destinations-hero">
          <div className="destinations-hero-overlay"></div>
          <div className="destinations-hero-content">
            <h1 className="destinations-hero-title">OUR DESTINATIONS</h1>
            <p className="destinations-hero-subtitle">
              Discover the most beautiful places in God's Own Country
            </p>
            <div className="destinations-stats">
              <div className="stat">
                <span className="stat-number">12+</span>
                <span className="stat-text">Amazing Destinations</span>
              </div>
              <div className="stat">
                <span className="stat-number">5000+</span>
                <span className="stat-text">Happy Travelers</span>
              </div>
              <div className="stat">
                <span className="stat-number">24/7</span>
                <span className="stat-text">Travel Support</span>
              </div>
            </div>
          </div>
        </div>

        {/* Destinations Grid */}
        <div className="destinations-container">
          <Grid>
            <Row className="destinations-grid">
              {destinations.map((dest, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="destination-col">
                  <div className="destination-card">
                    <div className="card-image-wrapper">
                      <img 
                        src={dest.image} 
                        alt={dest.name}
                        className="card-image"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "https://via.placeholder.com/400x300?text=" + dest.name;
                        }}
                      />
                      <div className="card-overlay">
                        <div className="card-info">
                          <span className="duration">{dest.duration}</span>
                          <span className="best-time">Best: {dest.bestTime}</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="card-content">
                      <h3 className="destination-name" style={{ color: dest.color }}>
                        {dest.name}
                      </h3>
                      <p className="destination-description">{dest.description}</p>
                      
                      <Link to={dest.link} className="explore-destination-btn" style={{ background: dest.color }}>
                        <span>Explore</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>
      </div>
    );
  }
}